import { __decorate } from "tslib";
import { Route } from '../core';
import config from '@api/config';
var BankAccount = /*@__PURE__*/ (function () {
    function BankAccount() {
    }
    BankAccount.post = function (response) {
        return response;
    };
    BankAccount = __decorate([
        Route(config.BANKACCOUNT_ENDPOINT, true)
    ], BankAccount);
    return BankAccount;
}());
export { BankAccount };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/bankaccount.ts
// module id = null
// module chunks = 